import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=821d67ba&scoped=true"
import script from "./WordCloud.vue?vue&type=script&lang=js"
export * from "./WordCloud.vue?vue&type=script&lang=js"
import style0 from "./WordCloud.vue?vue&type=style&index=0&id=821d67ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821d67ba",
  null
  
)

export default component.exports